import { AddonsState } from 'editor/src/store/editorModules/addons/types';

const increaseRequestedVersionReducer = (state: AddonsState) => {
  if (state.data) {
    state.requestedVersion += 1;
  }
};

export default increaseRequestedVersionReducer;
